module.exports = __webpack_public_path__ + "static/media/1688small_1621433828078.eb8b1010.JPG";